import { General } from './general'
import { Section } from './section'

export const Config = { General, Section }
